import { combineReducers } from "@reduxjs/toolkit";
import unreadCount from "./unreadCountSlice";

const reducer = combineReducers({
    unreadCount,
});

export default reducer;
